<template>
  <div :class="$style.frameGroup">
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.frameParent">
        <div :class="$style.frameLending">
          <div :class="$style.usDollarParent">
            <img
              :class="$style.usDollarIcon"
              alt=""
              src="/static/img/usdollar.svg"
            />
            <b :class="$style.lendingOptions">Lending Options</b>
          </div>
          <div :class="$style.lendingOptionsParent">
            <div :class="$style.lendingOptions1">
              <div :class="$style.frameLendingGroup">
                <div :class="$style.groupParent">
                  <img
                    :class="$style.frameChild"
                    alt=""
                    src="/static/img/thunder.svg"
                  />
                  <div :class="$style.fastFundingWrapper">
                    <b :class="$style.fastFunding">Fast Funding</b>
                  </div>
                </div>
                <div :class="$style.getApprovedForContainer">
                  Get approved for funding within 48 hours! Submit all required
                  documents promptly for quick processing.
                  <span :class="$style.seeDetails">See Details</span>
                </div>
              </div>
              <div :class="$style.frameLendingContainer">
                <div :class="$style.aprEstWrapper">
                  <div :class="$style.aprEst">
                    <p :class="$style.label">
                      <b>11.58%</b>
                    </p>
                    <p :class="$style.label">APR Est.*</p>
                  </div>
                </div>
                <img
                  :class="$style.fmsbanklogo"
                  alt=""
                  src="/static/img/fmsbanklogo.png"
                />
                <img
                  :class="$style.frameChild"
                  alt=""
                  src="/static/img/heart2.svg"
                />
              </div>
              <div :class="$style.frameDiv">
                <div :class="$style.monthlyWrapper">
                  <div :class="$style.monthlyContainer">
                    <p :class="$style.label">
                      <b>$1,565.65/mo</b>
                    </p>
                    <p :class="$style.monthlyLabel">For 120 mo*</p>
                  </div>
                </div>
                <div :class="$style.interestAndFeesEstWrapper">
                  <div :class="$style.interestAndFeesContainer">
                    <p :class="$style.label">
                      <b>$76,881.20</b>
                    </p>
                    <p :class="$style.interestAndFees">
                      Interest and Fees Est.*
                    </p>
                  </div>
                </div>
                <div :class="$style.loanAmountWrapper">
                  <div :class="$style.loanAmount">
                    <p :class="$style.label">
                      <b>$110,997</b>
                    </p>
                    <p :class="$style.loanAmount1">Loan Amount</p>
                  </div>
                </div>
              </div>
              <hr />
              <div :class="$style.groupContainer">
                <img
                  :class="$style.frameInner"
                  alt=""
                  src="/static/img/badge.svg"
                />
                <div :class="$style.benefitsOrFeaturesContainer">
                  <p :class="$style.label">
                    <b :class="$style.benefitsOrFeatures"
                      >Benefits or Features:</b
                    >
                    <span> No prepayment penalty, </span>
                  </p>
                  <p :class="$style.label">
                    flexible terms, low fixed rates, 12-month deferral
                  </p>
                </div>
                <img
                  :class="$style.groupIcon"
                  alt=""
                  src="/static/img/info.svg"
                />
              </div>
              <div :class="$style.groupContainer">
                <div :class="$style.groupParent1">
                  <img
                    :class="$style.frameInner"
                    alt=""
                    src="/static/img/percentage.svg"
                  />
                  <div :class="$style.benefitsOrFeaturesContainer">
                    <span>Discounts: </span>
                    <b>Autopay</b>
                  </div>
                </div>
                <img
                  :class="$style.groupIcon"
                  alt=""
                  src="/static/img/info.svg"
                />
              </div>
              <div :class="$style.frameParentButtons">
                <div
                  :class="$style.takeOfferWrapper"
                  @click="onFrameContainerClick"
                >
                  <b :class="$style.benefitsOrFeaturesContainer">Take Offer</b>
                </div>
                <div :class="$style.editLoanAmountWrapper">
                  <b :class="$style.benefitsOrFeaturesContainer"
                    >Edit Loan Amount</b
                  >
                </div>
                <div :class="$style.seeLoanDetailsWrapper" @click="openOffers">
                  <div :class="$style.benefitsOrFeaturesContainer">
                    See details, rates and offers
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b>Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b>Back</b>
        </div>
      </div>
    </div>

    <PortalPopup
      overlayColor="rgba(113, 113, 113, 0.3)"
      v-show="showModal"
      placement="Centered"
      @close="closeModal"
    >
      <OfferDetailsModal @close="closeModal" />
    </PortalPopup>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import OfferDetailsModal from "../Steps/OfferDetails.vue";
import PortalPopup from "../PortalPopup.vue";

export default defineComponent({
  components: {
    PortalPopup,
    OfferDetailsModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    handleNext() {
      this.$emit("onNext");
    },
    onFrameContainerClick() {},
    openOffers() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
});
</script>

<style module scoped>
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}

.frameParent {
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  width: 100%;
  height: 705px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: center;
  font-size: 15px !important;
  color: #fff;
  font-family: Helvetica, Arial, sans-serif;
}

.frameParentButtons {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 60px 20px;
  gap: 20px;
  font-size: 15px;
  color: #7139a4;
}

.usDollarIcon {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}

.usDollarParent {
  align-self: stretch;
  background-color: #0d941f;
  height: 37px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 0 15px;
  box-sizing: border-box;
  gap: 10px;
  z-index: 0;
}

.lendingOptions {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.frameLending {
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  width: 100%;
  height: 740px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: center;
  font-size: 15px !important;
  color: #fff;
  font-family: Helvetica, Arial, sans-serif;
}

.lendingOptionsParent {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  gap: 15px;
  z-index: 1;
  text-align: left;
  font-size: 16px !important;
  color: #000;
}

.lendingOptions1 {
  width: 558px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}

.frameLendingGroup {
  align-self: stretch;
  border-radius: 15px 15px 0 0;
  background-color: #ffe4c9;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 20px;
  gap: 10px;
  font-size: 22px !important;
}

.frameLendingContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 33px 0 13px;
  gap: 0;
}

.frameChild {
  width: 20px;
  position: relative;
  height: 20px;
}
.fastFunding {
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fastFundingWrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.groupParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.seeDetails {
  text-decoration: underline;
}
.getApprovedForContainer {
  align-self: stretch;
  position: relative;
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.75);
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.label {
  margin: 0;
}
.aprEst {
  width: 74px;
  position: relative;
  display: inline-block;
}
.aprEstWrapper {
  width: 90px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  box-sizing: border-box;
}
.fmsbanklogo {
  width: 108px;
  position: relative;
  height: 47px;
  object-fit: cover;
}
.monthlyLabel {
  margin: 0;
  font-size: 16px !important;
  font-weight: 300;
  color: #000;
}
.monthlyContainer {
  width: 131px;
  position: relative;
  display: inline-block;
}
.monthlyWrapper {
  width: 135px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
}
.interestAndFees {
  margin: 0;
  font-size: 16px !important;
  font-weight: 300;
}
.interestAndFeesContainer {
  width: 166px;
  position: relative;
  display: inline-block;
}
.interestAndFeesEstWrapper {
  width: 164px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
}
.loanAmount1 {
  margin: 0;
  font-weight: 300;
  color: #000;
}
.loanAmount {
  width: 111px;
  position: relative;
  display: inline-block;
}
.loanAmountWrapper {
  width: 110px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
  font-size: 16px !important;
}
.frameDiv {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px;
  gap: 0;
  font-size: 18px !important;
  color: #676767;
}
.frameInner {
  width: 30px;
  position: relative;
  height: 30px;
}
.benefitsOrFeatures {
  font-family: Helvetica, Arial, sans-serif;
}
.benefitsOrFeaturesContainer {
  position: relative;
}
.groupIcon {
  width: 25px;
  position: relative;
  height: 25px;
}
.groupContainer {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  gap: 0;
}
.groupParent1 {
  width: 324px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 57px;
}
.takeOfferWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #7139a4;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
}
.editLoanAmountWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  border: 1.5px solid #7139a4;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
}
.seeLoanDetailsWrapper {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  cursor: pointer;
  pointer-events: auto;
}
p {
  font-size: 16px !important;
}
hr {
  display: block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  border-width: 1px;
}
</style>
